
export const FETCH_CONTACT_PROFILE_INFO_SUCCESS = 'FETCH_CONTACT_PROFILE_INFO_SUCCESS';
export const FETCH_CONTACT_PROFILE_INFO_FAILURE = 'FETCH_CONTACT_PROFILE_INFO_FAILURE';
export const FETCH_AGENT_PORTAL_PROFILE_INFO_SUCCESS = 'FETCH_AGENT_PORTAL_PROFILE_INFO_SUCCESS';
export const FETCH_AGENT_PORTAL_PROFILE_INFO_FAILURE = 'FETCH_AGENT_PORTAL_PROFILE_INFO_FAILURE';
export const FETCH_BACKGROUND_CHECK_INFO_SUCCESS = 'FETCH_BACKGROUND_CHECK_INFO_SUCCESS';
export const FETCH_BACKGROUND_CHECK_INFO_FAILURE = 'FETCH_BACKGROUND_CHECK_INFO_FAILURE';
export const FETCH_SUBPRODUCERS_INFO_SUCCESS = 'FETCH_SUBPRODUCERS_INFO_SUCCESS';
export const FETCH_SUBPRODUCERS_INFO_FAILURE = 'FETCH_SUBPRODUCERS_INFO_FAILURE';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
export const RESET_CONTACT_PROFILE_STATE = 'RESET_CONTACT_PROFILE_STATE';
export const RESET_AGENT_PROFILE_STATE = 'RESET_AGENT_PROFILE_STATE';
export const RESET_SUBPRODUCERS_STATE = 'RESET_SUBPRODUCERS_STATE';
export const RESET_PRODUCTS_STATE = 'RESET_PRODUCTS_STATE';
export const SET_PREFERENCES_STATE = 'SET_PREFERENCES_STATE';
export const SET_CUSTOM_ENROLLMENTS_STATE = 'SET_CUSTOM_ENROLLMENTS_STATE';
export const SET_AGENTS_STATE = 'SET_AGENTS_STATE';
export const SET_CUSTOM_LINKS_STATE = 'SET_CUSTOM_LINKS_STATE';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_CURRENT_USER_STATE = 'SET_CURRENT_USER_STATE';
export const SET_WEB_ALERTS_STATE = 'SET_WEB_ALERTS_STATE';
export const SET_CRITICAL_BANNER_STATE = 'SET_CRITICAL_BANNER_STATE';
export const SET_FROM_SIGNUP = 'SET_FROM_SIGNUP';
export const SET_FROM_FEDERATION = 'SET_FROM_FEDERATION';
export const SET_AGENCY_ID = 'SET_AGENCY_ID';

export const fetchContactProfileInfoSuccess = (contactProfileData) => ({
  type: FETCH_CONTACT_PROFILE_INFO_SUCCESS,
  payload: contactProfileData,
});

export const fetchContactProfileInfoFailure = (error) => ({
  type: FETCH_CONTACT_PROFILE_INFO_FAILURE,
  payload: error,
});

export const fetchAgentPortalProfileInfoSuccess = (agentProfileData) => ({
  type: FETCH_AGENT_PORTAL_PROFILE_INFO_SUCCESS,
  payload: agentProfileData,
});

export const fetchAgentPortalProfileInfoFailure = (error) => ({
  type: FETCH_AGENT_PORTAL_PROFILE_INFO_FAILURE,
  payload: error,
});

export const fetchBackgroundCheckSuccess = (backgroundCheckData) => ({
  type: FETCH_BACKGROUND_CHECK_INFO_SUCCESS,
  payload: backgroundCheckData,
});

export const fetchBackgroundCheckFailure = (error) => ({
  type: FETCH_BACKGROUND_CHECK_INFO_FAILURE,
  payload: error,
});

export const fetchSubproducersInfoSuccess = (subproducersData) => ({
  type: FETCH_SUBPRODUCERS_INFO_SUCCESS,
  payload: subproducersData,
});

export const fetchSubproducersInfoFailure = (error) => ({
  type: FETCH_SUBPRODUCERS_INFO_FAILURE,
  payload: error,
});

export const fetchProductsSuccess = (productsData) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: productsData,
});

export const fetchProductsFailure = (error) => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: error,
});

export const resetContactProfileInfo = () => ({
  type: RESET_CONTACT_PROFILE_STATE,
});

export const resetAgentProfileInfo = () => ({
  type: RESET_AGENT_PROFILE_STATE,
});

export const resetSubproducersInfo = () => ({
  type: RESET_SUBPRODUCERS_STATE,
});

export const resetProducts = () => ({
  type: RESET_PRODUCTS_STATE,
});

export const setPreferences = (preferences) => ({
  type: SET_PREFERENCES_STATE,
  payload: preferences,
});

export const setAgents = (agents) => ({
  type: SET_AGENTS_STATE,
  payload: agents,
});

export const setEnrollments = (enrollments) => ({
  type: SET_CUSTOM_ENROLLMENTS_STATE,
  payload: enrollments,
});

export const setCustomLinks = (customLinks) => ({
  type: SET_CUSTOM_LINKS_STATE,
  payload: customLinks,
});

export const setLoadingState = (isLoading) => ({
  type: SET_LOADING_STATE,
  payload: isLoading,
});

export const setCurrentUserState = (user) => ({
  type: SET_CURRENT_USER_STATE,
  payload: user,
});

export const setWebAlerts = (webAlerts) => ({
  type: SET_WEB_ALERTS_STATE,
  payload: webAlerts,
});

export const setCriticalBannerState = (value) => ({
  type: SET_CRITICAL_BANNER_STATE,
  payload: value,
});

export const setFromSignup = (fromSignup) => ({
  type: SET_FROM_SIGNUP,
  payload: fromSignup,
});

export const setFromFederation = (fromFederation) => ({
  type: SET_FROM_FEDERATION,
  payload: fromFederation,
});

export const setAgencyId = (agencyId) => ({
  type: SET_AGENCY_ID,
  payload: agencyId,
});
